module.exports = __webpack_public_path__ + "static/media/panel2.b37f1aa7.svg";